import { ReactNode } from 'react'

import i18n from 'i18next'

export const getInsuranceButtonText = ({
  noInsurances,
  hasSelected,
  priceText,
}: {
  noInsurances: boolean
  hasSelected: boolean
  priceText: string
}): ReactNode => {
  if (noInsurances) {
    return i18n.t('continue')
  }

  if (hasSelected) {
    return (
      <>
        {i18n.t('insurance_info.insurance_police_for', {
          price: priceText,
        })}
        &#8384;
      </>
    )
  }

  return i18n.t('insurance_info.without_insurance')
}
